export default function Solutions() {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Solutions Page</h1>
      <p>This is the Solutions page content.</p>
    </div>
  );
}
